export default __webpack_public_path__ + "static/8-b3c06883c91bda14aec70cc1d6cf2953.webp";